export const { NODE_ENV } = process.env

// TODO: Settled In-Person vs Classroom & Online vs Webinar
interface WorkshopTypeDictionary<T = any> {
	InPerson: T
	Online: T
}

export type WorkshopType = keyof WorkshopTypeDictionary

export const AllWorkshopTypes: Array<WorkshopType> = ['InPerson', 'Online']

export const WorkshopTypeIds: WorkshopTypeDictionary<number> = {
	InPerson: 1, 
	Online: 2
}

export type WorkshopStatusDictionary<T = any> = {
	Tentative: T
	Scheduled: T
	Completed: T
	Cancelled: T
	InProgress: T
}

export type WorkshopStatus = keyof WorkshopStatusDictionary

export const WorkshopStatusIds : WorkshopStatusDictionary<number> = {
	Scheduled: 1,
	InProgress: 2,
	Completed: 3,
	Cancelled: 4,
	Tentative: 5,
}

// TODO: Possibly eliminate these reverse lookups.  
// Refactor so that models use Ids more than "keywords", 
// which legacy API originally supplied
export const WorkshopStatusIdStatuses: {[key: number]: WorkshopStatus} = {
	1: 'Scheduled', 
	2: 'InProgress',
	3: 'Completed', 
	4: 'Cancelled', 
	5: 'Tentative'
}

export const ActiveWorkshopStatuses: WorkshopStatusDictionary<boolean> = {
	Tentative: true, 
	Scheduled: true, 
	Completed: false, 
	Cancelled: false,
	InProgress: true,
}

export const LegacyKeyStrings = {
	LocationTier1: 'MUNICIPALITYTIER1', 
	LocationTier2: 'MUNICIPALITYTIER2WORKSHOP', 
	CommodityCategory: 'COMMODITYCATEGORY', 
	CommoditySubCategory: 'COMMODITYSUBCATEGORYWORKSHOP',
	Province: 'PROVINCE', 
	Watershed: 'WATERSHED', 
}

export const Icons = {
	laptop: '💻', 
	checkmark: '✔', 
	chevronDown: '▼', 
	x: '✖', 
	plus: '✚', // '➕'
	minus: '−', // '➖'
	hamburger: '☰', 
	// arrowLeft: '🡄',
	// arrowUp: '🡅', 
	// arrowDown: '🡇', 
	calendar: '📅'// '📅' '📆' 
}

export const SpecialClassNames = {
	// enables elements (such as modals) to be rendered above filters and navs 
	// if the latter are sticky pinned when scrolling
	topZ: 'top-z', 

	// some modals look better when they are more compact
	narrowModal: 'narrow-modal'
}

let { /*OntarioProgramsUrl,*/ IdentityServerUrl, Environment, EnvironmentDisplay, HoursUntilRegistrationCutoff, StaticPagesWithBanner } = window.__GLOBALS__

export const Config = {
	Server: process.env.REACT_APP_SERVER,
	HomePagePath: process.env.REACT_APP_HOME_PAGE_PATH,
	MockApi: (process.env.REACT_APP_MOCK_API === 'true'), 
	MockApiLatency: Number.parseInt(process.env.REACT_APP_MOCK_API_LATENCY!), 
	SessionWarningThreshold: Number.parseInt(process.env.REACT_APP_SESSION_WARNING_THRESHOLD!), 
	Environment, 
	EnvironmentDisplay, 
	// OntarioProgramsUrl,
	IdentityServerUrl,
	IdentityServerLoginAndReturnPath: process.env.REACT_APP_IDENTITY_SERVER_LOGIN_AND_RETURN_PATH, 
	HoursUntilRegistrationCutoff, 
	RegistrationCutoffCheckInterval: Number.parseInt(process.env.REACT_APP_REGISTRATION_CUTOFF_CHECK_INTERVAL!), 
	HoursUntilRegistrationCutoffNotificationWarning: Number.parseInt(process.env.REACT_APP_HOURS_UNTIL_REGISTRATION_CUTOFF_NOTIFICATION_WARNING!),
	HoursUntilRegistrationCutoffNotificationDanger: Number.parseInt(process.env.REACT_APP_HOURS_UNTIL_REGISTRATION_CUTOFF_NOTIFICATION_DANGER!),
	StaticPagesWithBanner: (StaticPagesWithBanner || '').split(',').map(s => s.trim()).filter(s => s.length > 0)
}